import { Stack } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import ErrorFullScreenMessage from "../../../../components/fullScreenMessage/ErrorFullScreenMessage";
import Loader from "../../../../components/loader/Loader";
import PageContentWrapper from "../../../../components/wrappers/PageContentWrapper";
import { useFetchClinicData } from "../../../master/clinics/utils/DataFetching";
import ClinicEditingForm from "../components/ClinicEditingForm";
import { useRedirectIfNotOwnClinic } from "../../../../hooks/useRedirectIfNotOwnClinic";
import useUser from "../../../../hooks/useUser";
import { MASTER_LAST_BROWSED_CLINIC_ID_KEY } from "../../../../utils/masterBrowsingContext";

export default function ClinicView() {
  const { id } = useParams();
  useRedirectIfNotOwnClinic(id);
  const { roles } = useUser();
  const { data, isLoading, error } = useFetchClinicData(id);

  // Master has no clinic of their own, so nothing else in the app tracks
  // "which clinic is master currently looking at" - remember it here so the
  // persistent nav-bar Warehouse link can resolve to the right clinic
  // instead of a dead, id-less URL.
  React.useEffect(() => {
    if (roles.master && id) {
      sessionStorage.setItem(MASTER_LAST_BROWSED_CLINIC_ID_KEY, id);
    }
  }, [roles.master, id]);

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return <ErrorFullScreenMessage />;
  }
  return (
    <PageContentWrapper>
      <Stack spacing={2}>
        <ClinicEditingForm clinic={data.clinic} />
      </Stack>
    </PageContentWrapper>
  );
}
